import { Box, Button, Col, Row, Text } from '@opendoor/bricks-next';
import { EntryComponent } from 'cms/entries/entries';
import { ILpComponentLwcImageCard } from 'declarations/contentful';

import Grid, { gridStyles } from './Grid';

const RenderLWCImageCard = (entry: ILpComponentLwcImageCard) => {
  const { fields, sys } = entry;
  const desktopImageSourceUrl = fields?.desktopImage;
  const mobileImageSourceUrl = fields?.mobileImage;
  const isSmallPadding = fields?.verticalPadding === 'Small';

  if (sys.locale === 'es') return;

  return (
    <Col
      analyticsName={`cosmos-landing-page-lwc-image-card-${fields?.analyticsId}`}
      trackImpression
    >
      <Grid backgroundColor="$backgroundSecondary">
        <Box
          $platform-web={{ gridColumn: gridStyles.colSpan12 }}
          flexDirection="column"
          width="100%"
          height="$500x"
          my={isSmallPadding ? '$10x' : '$56x'}
          $largerThanXS={{
            height: '$616x',
            ...(isSmallPadding ? { my: '$16x' } : { my: '$80x' }),
          }}
          $largerThanSM={{
            flexDirection: 'row',
            height: '$452x',
            ...(isSmallPadding ? { my: '$24x' } : {}),
          }}
          $largerThanMD={{ height: '$719x' }}
          overflow="hidden"
          backgroundColor="$backgroundPrimary"
          borderRadius="$16x"
        >
          <Col
            p="$16x"
            pr="$12x"
            pb="$22x"
            $largerThanSM={{ pr: '$16x', pb: '$16x' }}
            $largerThanMD={{ p: '$32x' }}
            $largerThanLG={{ p: '$40x' }}
            justifyContent="flex-start"
          >
            {fields?.subtitle && (
              <Row flexGrow={1} pb="$6x" $largerThanSM={{ pb: '$0x' }}>
                <Text
                  tag="h3"
                  display="block"
                  typography="$bodyLarge"
                  fontWeight="$medium"
                  color="$contentPrimary"
                >
                  {fields.subtitle}
                </Text>
              </Row>
            )}
            <Col>
              <Col
                width="100%"
                maxWidth="$200x"
                $largerThanXS={{ maxWidth: '$310x' }}
                $largerThanSM={{ maxWidth: '$272x' }}
                $largerThanMD={{ maxWidth: '$500x' }}
              >
                <Text
                  tag="h3"
                  display="block"
                  typography="$subheaderMedium"
                  $largerThanMD={{ typography: '$headerLarge' }}
                >
                  {fields.title}
                </Text>
              </Col>
              {fields?.ctaLink && fields?.ctaDisplayText && (
                <Button
                  variant="primary"
                  aria-label={`Go to page to ${fields?.ctaDisplayText}`}
                  analyticsName={`cosmos-landing-page-lwc-image-card-cta-${fields?.analyticsId}`}
                  onPress={() => fields?.ctaLink && window.location.assign(fields?.ctaLink)}
                  mt="$15x"
                  size="small"
                  maxWidth="$165x"
                  label={fields?.ctaDisplayText}
                />
              )}
            </Col>
          </Col>
          <Box flex={1} flexBasis={0} $largerThanSM={{ p: '$8x' }} $largerThanMD={{ p: '$10x' }}>
            <Box
              $platform-web={{ display: 'grid' }}
              overflow="hidden"
              width="100%"
              height="100%"
              $largerThanSM={{ borderRadius: '$8x' }}
            >
              <picture style={{ display: 'contents' }}>
                <source media="(min-width: 768px)" srcSet={desktopImageSourceUrl} />
                <img
                  src={mobileImageSourceUrl}
                  alt="illustration of a home"
                  loading="lazy"
                  decoding="async"
                  style={{
                    display: 'block',
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: '80%',
                  }}
                />
              </picture>
            </Box>
          </Box>
        </Box>
      </Grid>
    </Col>
  );
};

const LWCImageCard: EntryComponent<ILpComponentLwcImageCard> = {
  render: RenderLWCImageCard,
};

export default LWCImageCard;
